import {getAxiosInstance} from "../../../np-rest/rest";
import {snackActions} from "../../../sc-utilities/SnackBar";

export const fetchAdminDiagnoseCasesCount = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let countRes = await rest.post("/diagnose-case/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                return countRes.data.result.data;
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch diagnose cases."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch diagnose cases."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchAdminDiagnoseCases = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let countRes = await rest.post("/diagnose-case/list", filterData);
            if (countRes.data && countRes.data.succeeded) {
                return countRes.data.result.data;
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch diagnose cases."}`,
                options: {
                    variant: 'warning'
                }
            });
            return [];
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch diagnose cases."}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    }
}

export const fetchAdminDiagnoseCase = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let countRes = await rest.post("/diagnose-case/load", filterData);
            if (countRes.data && countRes.data.succeeded) {
                return countRes.data.result.data;
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch diagnose case."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch diagnose case."}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    }
}

export const updateAdminDiagnoseCase = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let countRes = await rest.post("/diagnose-case/update", filterData);
            if (countRes.data && countRes.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated diagnose case.`,
                    options: {
                        variant: 'success'
                    }
                });
                return countRes.data.result.data;
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot update diagnose case."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot update diagnose case."}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    }
}

export const createAdminDiagnoseCase = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let countRes = await rest.post("/diagnose-case/create", filterData);
            if (countRes.data && countRes.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created diagnose case.`,
                    options: {
                        variant: 'success'
                    }
                });
                return countRes.data.result.data;
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot create diagnose case."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot create diagnose case."}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    }
}

export const bulkDeleteAdminDiagnoseCases = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post('/diagnose-case/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                        message: `Successfully deleted diagnose cases.`,
                        options: {
                            variant: 'success'
                        }
                    });
                return
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot delete diagnose cases."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const updateAdminDiagnoseCaseParams = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let countRes = await rest.post("diagnose-case/update-case-params", filterData);
            if (countRes.data && countRes.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated diagnose case parameters.`,
                    options: {
                        variant: 'success'
                    }
                });
                return countRes.data.result.data;
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot update diagnose case parameters."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot update diagnose case parameters."}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    }
}